﻿import React, { useEffect, useState } from "react";
import { Loading } from "./Components/Loading";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface INoTenancyProps {}

interface IOrphanDate {
    day: number;
    month: number;
    year: number;
}

export const NoTenancy: React.FunctionComponent<INoTenancyProps> = (
    props,
): React.ReactElement => {
    const [hasError, setHasError] = useState<boolean>(false),
        [isLoading, setIsLoading] = useState<boolean>(true),
        [orphanDate, setOrphanDate] = useState<Date>(null);

    const dayDif = (date1: Date, date2: Date): number =>
            Math.floor(Math.abs(date1.getTime() - date2.getTime()) / 86400000),
        initialize = (): void => {
            void fetch(`/Tenancy/GetOrphanDate`).then((resp) => {
                void resp
                    .json()
                    .catch((error) => {
                        console.error(error);
                        setHasError(true);
                    })
                    .then((data) => {
                        const newDate: IOrphanDate = data as IOrphanDate;

                        setOrphanDate(
                            new Date(
                                newDate.year,
                                newDate.month - 1,
                                newDate.day,
                            ),
                        );
                    })
                    .finally(() => setIsLoading(false));
            });
        };

    useEffect(() => initialize(), []);

    if (isLoading) {
        return <Loading />;
    } else {
        let message = `Your account does not have any active Tenancy subscriptions and will be automatically closed`;

        if (hasError) {
            message = message.concat(`.`);
        } else {
            const numDays = 7 - dayDif(orphanDate, new Date());

            message = message.concat(
                ` in ${numDays} day${numDays > 1 ? `s` : ``}.`,
            );
        }

        return (
            <div className={`no-tenancy`}>
                <img
                    src={`/Images/Alert_Graphic.svg`}
                    style={{
                        width: `240px`,
                    }}
                />
                <p>{message}</p>
            </div>
        );
    }
};
